import App from '../index.js';
import { isEmpty } from 'lodash';

App.SurveyResponse = (function () {
    // Function to start the timer
    const elSurveyResponseForm = $('#survey_response_form');
    const elSurveyCompleted = $('#survey_completed');
    let startedTheSurvey = false;
    let submittingSurvey = false;
    const noInteractionRestartDelayInSeconds = elSurveyResponseForm.data('no-interaction-restart-delay') || 0;
    const autoRestartDelayInSeconds = elSurveyCompleted.data('auto-restart-delay') || 0;
    const baseUrl = $('#survey_response_form, #survey_completed').data('base-url');
    const pageRouteName = $('.page_route').val();
    let noInteractionTimer;

    const CONDITIONAL_OPERATOR_EQUAL_TO = 'equal_to';
    const CONDITIONAL_OPERATOR_LESS_THAN_OR_EQUAL_TO = 'less_than_or_equal_to';
    const CONDITIONAL_OPERATOR_GREATER_THAN_OR_EQUAL_TO = 'greater_than_or_equal_to';

    function getRGB ( c ) {
        return parseInt(c, 16) || c
    }

    function getsRGB ( c ) {
        return getRGB(c) / 255 <= 0.03928
            ? getRGB(c) / 255 / 12.92
            : Math.pow((getRGB(c) / 255 + 0.055) / 1.055, 2.4)
    }

    function getLuminance ( hexColor ) {
        return (
            0.2126 * getsRGB(hexColor.substr(1, 2)) +
            0.7152 * getsRGB(hexColor.substr(3, 2)) +
            0.0722 * getsRGB(hexColor.substr(-2))
        )
    }

    function getContrast ( f, b ) {
        const L1 = getLuminance(f)
        const L2 = getLuminance(b)
        return (Math.max(L1, L2) + 0.05) / (Math.min(L1, L2) + 0.05)
    }

    function getTextColor ( bgColor ) {
        const whiteContrast = getContrast(bgColor, '#ffffff')
        const blackContrast = getContrast(bgColor, '#000000')

        return whiteContrast > blackContrast ? '#ffffff' : '#000000'
    }

    function updateStyling () {
        let el = $('.preview-holder'),
            elHeader = el.find('.header');

        el.find('.header').css({
            'background-color': elHeader.data('bgcolor'),
            'color': elHeader.data('textcolor') ? elHeader.data('textcolor') : getTextColor(elHeader.data('bgcolor') || '#ffffff')
        });
    }

    function languageChange () {
        $('#filter_form')[0].submit();
    }

    function onSubmitLandingForm () {
        elSurveyResponseForm[0].submit();
    }

    function noAnswerFound ( el ) {
        if (el.is(':radio') || el.is(':checkbox')) {
            return !el.closest('.question-item').find('.target-field:checked').length;
        }

        return !el.val();
    }

    function onSubmitSurveyResponseForm ( e ) {
        let formValid = true,
            firstErrorEl = null;

        // Temporarily disable no interaction to avoid refresh when server takes sometime to response during submission.
        submittingSurvey = true;

        $(this).find('.question-item .invalid-feedback').remove();

        $(this).find('[type="submit"]').attr('disabled', 'disabled');

        // Check each required input field
        $(this).find('.question-item:not(.d-none).is-required').find('.target-field').each(function () {

            const el = $(this),
                elParent = el.closest('.question-item'),
                hasError = noAnswerFound(el);

            if (hasError) {
                if (!elParent.find('.invalid-feedback')[0]) {
                    elParent.append('<div class="invalid-feedback d-block mb-3">' + elParent.data('required-error-message') + '</div>');
                }

                formValid = false;

                if (!firstErrorEl) {
                    firstErrorEl = el;
                }
            }
        });

        // For any hidden (conditional) questions or questions that was not met for display will remove the selection and values.
        clearHiddenConditionalQuestionAnswers();

        firstErrorEl?.focus();

        // If any field is not valid, prevent form submission
        if (!formValid) {
            // Enable no interaction
            submittingSurvey = false;
            $(this).find('[type="submit"]').removeAttr('disabled');
            e.preventDefault();
        }
    }

    function clearHiddenConditionalQuestionAnswers () {
        const elParent = $('.question-item.d-none');

        elParent.find('input[type="radio"], input[type="checkbox"]').prop('checked', false);
        elParent.find('input[type="text"], textarea, select').val('');
        elParent.find('input[type="range"]').val(0);
    }

    function handleInputRange () {
        $(this).closest('.form-slider-group').find('.value').text($(this).val());
    }

    function handleClearButton () {
        const elParent = $(this).closest('.question-item'),
            fieldName = elParent.find('.target-field:first').attr('name'),
            elField = elParent.find('[name="' + fieldName + '"]');

        elField.removeAttr('checked').prop('checked', false);
        elParent.find('input[type="radio"]:checked, input[type="range"]');

        const surveyItemId = elParent.data('survey-item-id');
        validateConditionalQuestionsVisibility(surveyItemId, undefined);
    }

    function handleUserInteraction () {
        // Clear the existing timer, if any
        clearTimeout(noInteractionTimer);

        // Set a new timer for 2 seconds (adjust as needed)
        noInteractionTimer = setTimeout(function () {
            // Action to perform after the timer expires
            console.log("Timer expired after no interaction.");
            if (!submittingSurvey) {
                window.location = baseUrl;
            }
        }, noInteractionRestartDelayInSeconds * 1000); // 2000 milliseconds = 2 seconds
    }

    function handleAutoRestartDelay () {
        setTimeout(function () {
            window.location = baseUrl;
        }, autoRestartDelayInSeconds * 1000);
    }

    function validateConditionalQuestionsVisibility ( surveyItemId, selectedValue, forceHideQuestion = false ) {
        $('.is-conditional-question[data-conditional-survey-item-id="' + surveyItemId + '"]').each(function () {
            const elConditionalQuestion = $(this);
            const operator = elConditionalQuestion.data('conditional-operator');
            const requirementValue = parseInt(elConditionalQuestion.data('conditional-operator-value'));

            // The forceHideQuestion is a way to hide nested conditional questions if the parent is hidden.
            if (!forceHideQuestion && selectedValue !== undefined && ((operator === CONDITIONAL_OPERATOR_EQUAL_TO && selectedValue === requirementValue) ||
                (operator === CONDITIONAL_OPERATOR_LESS_THAN_OR_EQUAL_TO && selectedValue <= requirementValue) ||
                (operator === CONDITIONAL_OPERATOR_GREATER_THAN_OR_EQUAL_TO && selectedValue >= requirementValue))) {
                elConditionalQuestion.removeClass('d-none');
            } else {
                elConditionalQuestion.addClass('d-none');
            }

            // check for more conditional questions
            const subSurveyItemId = elConditionalQuestion.data('survey-item-id');
            const subSelectedValue = parseInt(elConditionalQuestion.find('input[type="radio"]:checked, input[type="range"]').val());
            validateConditionalQuestionsVisibility(subSurveyItemId, subSelectedValue, elConditionalQuestion.hasClass('d-none'));
        });
    }

    function setupConditionalQuestions () {
        // First Identify the conditional questions
        $('.is-conditional-question').each(function ( index ) {
            const parentID = $(this).data('conditional-survey-item-id');

            // add a class to identify the corresponding parent question
            $('#survey_item_id_' + parentID).addClass('is-conditional-parent-question');
        });


        // Add an event listener to listen to the parent questions answers
        $('body .is-conditional-parent-question').on('change', 'input[type="radio"], input[type="range"]', function () {
            const el = $(this);
            const elQuestionItem = el.closest('.question-item');
            const selectedValue = parseInt(el.val());
            const surveyItemId = elQuestionItem.data('survey-item-id');

            // now identify all conditional questions and check the condition
            validateConditionalQuestionsVisibility(surveyItemId, selectedValue);
        }).find('input[type="radio"]:checked, input[type="range"]').trigger('change'); // when the page loaded.
    }

    function submitIfOnlySingleQuestionIsDisplayed () {
        const numberOfVisibleQuestions = $('.question-list .question-item:not(.d-none)').length;
        const elForm = $('#survey_response_form')[0];

        if (numberOfVisibleQuestions <= 1 && pageRouteName === 'surveys.edit' && elForm
            && !$('#survey_completed')[0] && !$('.question-list .question-item .invalid-feedback')[0]) {
            const questionEl = $('.question-list .question-item:not(.d-none):first');
            const type = questionEl.find('.target-field').attr('type');

            // Making sure that in 2nd page it only auto submits if the question has been answered.
            if ((['radio', 'checkbox'].includes(type) && questionEl.find('.target-field:checked').length >= 1) || !isEmpty(questionEl.find('.target-field').val())) {
                    elForm.submit();
            } else {
                $('.survey-body-wrapper').removeClass('opacity-0');
            }
        } else {
            $('.survey-body-wrapper').removeClass('opacity-0');
        }
    }

    function setupNoUserInteraction() {
        handleUserInteraction();

        if(!startedTheSurvey) {
            document.addEventListener("click", handleUserInteraction);
            document.addEventListener("keydown", handleUserInteraction);
            document.addEventListener("mousemove", handleUserInteraction);
            document.addEventListener("touchmove", handleUserInteraction);
        }

        startedTheSurvey = true;
    }

    function attemptAutoSubmitSurvey() {
        if ($('#survey_response_form').hasClass('auto-submit-on-load')) {
            document.getElementById('survey_response_form').submit();
        }
    }

    return {
        init: function () {
            attemptAutoSubmitSurvey();


            updateStyling();
            setupConditionalQuestions();
            submitIfOnlySingleQuestionIsDisplayed();

            if (!$('.survey-wrapper .survey-body').hasClass('only-fill-out-once')) {
                if (pageRouteName === 'surveys.edit') {
                    if (elSurveyCompleted[0] && autoRestartDelayInSeconds) {
                        handleAutoRestartDelay();
                    } else if (noInteractionRestartDelayInSeconds) {
                        $('body').on('change', '.survey-wrapper .survey-body:not(.survey-landing) .question-list .question-item .target-field', setupNoUserInteraction);
                    }
                }
            }

            $('body').on('change', '#language_selector', languageChange)
                .on('change', '.survey-wrapper .survey-body.survey-landing .form-thumbs-group input', onSubmitLandingForm)
                .on('change', '.survey-wrapper .survey-body.survey-landing .rate-form-group input', onSubmitLandingForm)
                .on('change', '.survey-wrapper .survey-body.survey-landing .smiley-form-group input', onSubmitLandingForm)
                .on('change', '.survey-wrapper .survey-body.survey-landing .yes-or-no-form-group input', onSubmitLandingForm)
                .on('submit', '#survey_response_form', onSubmitSurveyResponseForm)
                .on('input', '.form-slider-group input[type="range"]', handleInputRange)
                .on('click', '.survey-wrapper .survey-content.question-list .question-item .btn-clear', handleClearButton);


            // Enable submit button once fully loaded.
            $('#survey_response_form [type="submit"]').removeAttr('disabled');
        }
    };

})();

// Provide the route name
App.registerRoute('surveys.create', App.SurveyResponse.init);
App.registerRoute('surveys.edit', App.SurveyResponse.init);

export default App.SurveyResponse;
